import HrStaffPage from "./pages/HrStaffPage";
import HrStaffDetailPage from "./pages/HrStaffDetailPage";
import HrAttendancePage from "./pages/HrAttendancePage";
import HrLeavePage from "./pages/HrLeavePage";

/** HR is secretariat-facing: the API gates every endpoint on admin|super_admin. */
export const hrRoutes = [
  { path: "/hr/staff", element: <HrStaffPage />, roles: ["admin"] },
  { path: "/hr/staff/:id", element: <HrStaffDetailPage />, roles: ["admin"] },
  { path: "/hr/attendance", element: <HrAttendancePage />, roles: ["admin"] },
  { path: "/hr/leave", element: <HrLeavePage />, roles: ["admin"] },
];
